/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IIndexedNode } from '../../../core/models/IIndexedNode';
import { Node } from '../../../core/models/Node';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas20Visitor } from '../visitors/IOas20Visitor';

/**
 * Models an OpenAPI 2.0 responses.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends Node
 */
export class Oas20ResponseDefinitions extends Node implements IIndexedNode<Oas20ResponseDefinition> {
    public items : any;

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas20Visitor = <IOas20Visitor><any>visitor;
        viz.visitResponseDefinitions(this);
    }

    /**
     * Returns a single response by name.
     * @param {string} name
     * @return {Oas20ResponseDefinition}
     */
    public getResponse(name : string) : Oas20ResponseDefinition {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.items, name);
    }

    /**
     * Returns an array of all the responses.
     * @return {Oas20ResponseDefinition[]}
     */
    public getResponses() : Array<Oas20ResponseDefinition> {
        let rval : Array<Oas20ResponseDefinition> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.items));
        return rval;
    }

    /**
     * Adds a response.
     * @param {string} name
     * @param {Oas20ResponseDefinition} response
     * @return {Oas20ResponseDefinition}
     */
    public addResponse(name : string, response : Oas20ResponseDefinition) : Oas20ResponseDefinition {
        /* put */(this.items[name] = response);
        return response;
    }

    /**
     * Removes a response by name.
     * @param {string} name
     * @return {Oas20ResponseDefinition}
     */
    public removeResponse(name : string) : Oas20ResponseDefinition {
        return /* remove */(map => { let deleted = this.items[name];delete this.items[name];return deleted;})(this.items);
    }

    /**
     * Gets a list of all the response names.
     * @return {string[]}
     */
    public getResponseNames() : Array<string> {
        let rval : Array<string> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this.items));
        return rval;
    }

    /**
     * Creates an OAS 2.0 Response object.
     * @param {string} name
     * @return {Oas20ResponseDefinition}
     */
    public createResponse(name : string) : Oas20ResponseDefinition {
        let rval : Oas20ResponseDefinition = new Oas20ResponseDefinition(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItem(java.lang.String)
     * @param {string} name
     * @return {Oas20ResponseDefinition}
     */
    public getItem(name : string) : Oas20ResponseDefinition {
        return this.getResponse(name);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItems()
     * @return {Oas20ResponseDefinition[]}
     */
    public getItems() : Array<Oas20ResponseDefinition> {
        return this.getResponses();
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItemNames()
     * @return {string[]}
     */
    public getItemNames() : Array<string> {
        return this.getResponseNames();
    }

    public addItem$java_lang_String$io_apicurio_datamodels_openapi_v2_models_Oas20ResponseDefinition(name : string, item : Oas20ResponseDefinition) {
        this.addResponse(name, item);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#addItem(java.lang.String, io.apicurio.datamodels.core.models.Node)
     * @param {string} name
     * @param {Oas20ResponseDefinition} item
     */
    public addItem(name? : any, item? : any) : any {
        if(((typeof name === 'string') || name === null) && ((item != null && item instanceof <any>Oas20ResponseDefinition) || item === null)) {
            return <any>this.addItem$java_lang_String$io_apicurio_datamodels_openapi_v2_models_Oas20ResponseDefinition(name, item);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#deleteItem(java.lang.String)
     * @param {string} name
     * @return {Oas20ResponseDefinition}
     */
    public deleteItem(name : string) : Oas20ResponseDefinition {
        return this.removeResponse(name);
    }

    constructor() {
        super();
        this.items = <any>({});
    }
}
Oas20ResponseDefinitions["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20ResponseDefinitions";
Oas20ResponseDefinitions["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];





import { Oas20ResponseDefinition } from './Oas20ResponseDefinition';

